// extracted by mini-css-extract-plugin
module.exports = {"container":"i_A3","provider":"i_A4","left":"i_A5","right":"i_A6","top":"i_A7","bottom":"i_A8","label-container":"i_A9","wrapper":"i_BA","asterisk":"i_BB"};